var CartItemQuantityComponent = Vue.component('cart-item-quantity', {
    template: '<div class="form-group text"><input :value="item.quantity" :data-cart-id="item.cart_id" type="text" class="form-control ui-spinner ui-spinner-input" ref="spinner" /></div>',
    props: ['item', 'min', 'max', 'holder'],
    data: function () {
        var holder = this.holder;

        if (typeof holder == 'string') {
            holder = {};
            holder[this.holder] = true;
        }

        if (typeof holder != 'object') {
            holder = {};
        }

        return {
            'quantity': this.item.quantity,
            'max': null,
            'min': 1,
            'holder': _.extend({
                'ui-spinner': true,
                'ui-widget': true
            }, holder)
        };
    },
    created: function() {
        var _self = this;

        $(function() {
            setTimeout(function() {
                $(_self.$refs.spinner)
                    .spinner($.extend(Spinner.options, {
                        spin: function (event, ui) {
                        },
                        stop: function(event) {
                            _self.updateQuantity($(event.target).val());
                        }
                    }))
                    .bind('change', function() {
                        var quantity = _self.updateQuantity($(this).val());

                        if (!quantity) {
                            return;
                        }

                        $(_self.$refs.spinner).data('uiSpinner').value(quantity);
                    })
                    .unbind('mousewheel');;
            }, 10);
        });
    },
    methods: {
        updateQuantity: function(quantity) {
            var _self = this;

            quantity = parseInt(quantity);
            if (!quantity) {
                quantity = 1;
            }

            if (_self.item.max_order_quantity && _self.item.max_order_quantity < quantity) {
                quantity = _self.item.max_order_quantity;
            }

            if (quantity == _self.item.quantity) {
                return false;
            }

            _self.item.quantity = quantity;
            _self.change();

            return quantity;
        },
        change: function () {
            this.$store.dispatch('changeProductQuantity', this.item);
        }
    }
});
